module.exports = __webpack_public_path__ + "static/tmp-demo-modal-c051ae5923711ac15c5ce318a8136630.png";